import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { Button } from '@material-ui/core'
import { formatDateMonth } from 'src/utils/commonMethods/formatDate'
import { useSelector } from 'react-redux'

const VehicleDetailsCard = ({
  isSubmitted,
  registerVehicleDetails,
  switchSelectComponent,
  handleSubmit,
  handlePrevious,
  handleNext,
  selectedIndex,
  setIsSubmitted,
  setIsActiveSection,
  vehicleButtonName,
}) => {
  const classes = useStyles()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const isVehiclePrefilledData = motorDetails?.isVehicleDetailsFetched
  const vehicleDetails = motorDetails?.vehicleDetails
  const renderNextButton = () => {
    if (selectedIndex >= 0 && selectedIndex < 4) {
      return (
        <>
          <Button
            onClick={handleNext}
            size='small'
            variant='contained'
            className={classes.submitBtn}
          >
            Next
          </Button>
        </>
      )
    }
    return null
  }

  return (
    <Box>
      <Box className={classes.vehicleCard}>
        {isSubmitted || isVehiclePrefilledData ? (
          <Box className={classes.vehicleDetailsCard}>
            <Box className={classes.brandDetails}>
              <Box>
                <img
                  src={vehicleDetails?.vehicleLogo}
                  alt={'brandLogo'}
                  className={classes.logo}
                />
              </Box>
              <Box className={classes.brandText}>
                {registerVehicleDetails?.brand?.genericName}
              </Box>
              <Box className={classes.modelText}>
                <span>{registerVehicleDetails?.model?.modelGenericName}</span>
                <span>
                  {registerVehicleDetails.variant?.genericVariantName
                    ? `(${registerVehicleDetails?.variant?.genericVariantName})`
                    : null}
                </span>
              </Box>
            </Box>
            <Box className={classes.fuelDetails}>
              <Box className={classes.dateText}>
                {formatDateMonth(registerVehicleDetails?.regDate)}
              </Box>
              <Box className={classes.dateText}>
                {registerVehicleDetails?.fuelType?.genericName}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box className={classes.vehicleEditContainer}>
            <Box className={classes.vehicleconatinerHeading}>
              Select Vehicle Details
            </Box>
            <Box className={classes.vehicleBtnContainer}>
              {selectedIndex > 0 && (
                <KeyboardArrowLeftIcon
                  className={classes.arrowButton}
                  onClick={handlePrevious}
                />
              )}

              <Box>{switchSelectComponent()}</Box>

              {selectedIndex < 4 && (
                <KeyboardArrowRightIcon
                  className={classes.arrowButton}
                  onClick={handleNext}
                />
              )}
            </Box>
            <Box>
              {renderNextButton()}
              {selectedIndex === 4 && (
                <Button
                  onClick={handleSubmit}
                  size='small'
                  variant='contained'
                  className={classes.submitBtn}
                >
                  Submit
                </Button>
              )}
            </Box>
          </Box>
        )}
      </Box>

      {!isVehiclePrefilledData && isSubmitted ? (
        <Box className={classes.notKuttiContainer}>
          <Button
            className={classes.notKuttiBtn}
            onClick={() => {
              setIsSubmitted(false)
              setIsActiveSection(true)
            }}
          >
            Not your {vehicleButtonName}?
          </Button>
        </Box>
      ) : null}
    </Box>
  )
}
const useStyles = makeStyles({
  vehicleCard: {
    borderRadius: 10,
    margin: '0px 20px',
    backgroundColor: '#FFFFFF',
  },
  vehicleDetailsCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    gap: 15,
  },
  brandDetails: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fuelDetails: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    gap: 30,
  },
  brandText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#9D9D9D',
  },
  modelText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  dateText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '15px',
    letterSpacing: '0em',
    textAlign: 'center',
  },

  vehicleEditContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 15,
    gap: 15,
  },
  vehicleBtnContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  vehicleconatinerHeading: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0em',
    color: '#000000',
  },
  selectWidth: {
    minWidth: 140,
    fontSize: '11px !important',
  },
  notKuttiContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#34A6C5',
  },
  notKuttiBtn: {
    color: '#34A6C5',
    textTransform: 'none',
  },
  submitBtn: {
    color: '#FFFFFF',
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%)',
  },
  inputWidth: {
    width: 140,
    fontSize: '12px !important',
  },
  arrowButton: {
    marginTop: 4,
  },
  autoStyle: {
    fontSize: '12px !important',
    height: '8px !important',
  },
  logo: {
    height: '40px',
    width: '40px',
  },
})
export default VehicleDetailsCard
